<template>
    <button class="btn btn-warning" @click="KelasAktivitasData">
        <slot><i class="fas fa-star"></i></slot>
    </button>
</template>

<script>
    import { EventBus } from '../eventBus.js';

    export default{
        //extends: ExampleComponent,
        props: ['id', 'name'],
        methods: {
            KelasAktivitasData() {
                // alert(`I am ${this.name}!`)
                EventBus.$emit('kelasAktivitasValue', this.id,this.name) 
            }
        },
    }
</script>